export default {"src":"/_next/static/media/Visa.7a36d7d4.svg","height":16,"width":50};